import styled from 'styled-components';

export default styled.ul`
  margin: 0;
  padding: 0 0 .5rem .5rem;
  display: flex;
  flex-direction: column;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    padding: .5rem;
    background-color: ${(props) => props.theme.primaryColor};
    position: absolute;
    top: 100%;
    left: 1rem;
    display: none;
    border-radius: ${(props) => props.theme.borderRadius};
  }
`;
